<template>
    <div>
         <!-- <button type="button" 
           style="position:fixed;top:0;left:0;z-index:1000;" 
                class="btn btn-sm btn-dark  rounded-circle">
             <span class="typcn typcn-media-play"></span>
        </button> -->
    </div>
</template>
<script>
export default{
    data(){
        return{
             
        }
    }
}
</script>